<div class="video-player">
	<div [hidden]="state() !== 'empty' || isPoppedOut()" class="video-slot-empty" role="status" aria-live="polite">
		<div class="video-slot-empty-icon" aria-hidden="true">
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
				<circle cx="12" cy="12" r="9" />
				<path d="M10 8.5L16 12L10 15.5V8.5Z" fill="currentColor" stroke="none" />
			</svg>
		</div>
		<p class="video-slot-empty-text">Select Main/Driver stream</p>
	</div>
	@if (isPoppedOut()) {
		<div class="video-slot-popout-message">
			<div class="popout-message-icon">
				<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<path d="M14 3h7v7" />
					<path d="M10 14L21 3" />
					<rect x="3" y="7" width="14" height="14" rx="2" ry="2" />
				</svg>
			</div>
			<span class="popout-message-text">Video playing in external window</span>
		</div>
	}
	<vb-lxp-video-player [hidden]="state() !== 'playing'" #mvPlayer></vb-lxp-video-player>
</div>

@if (showBadge && label && mvPlayer && mvPlayer.streamData) {
	<div class="stream-badge">
		<div class="stream-badge-dot"></div>
		@if (mvPlayer && mvPlayer.streamData && mvPlayer.streamData.carNumber) {
			<span class="stream-badge-text"># {{ mvPlayer.streamData.carNumber }}</span>
		} @else if (mvPlayer && mvPlayer.streamData.id === 'main-stream') {
			<span class="stream-badge-text">Main Stream</span>
		} @else {
			<span class="stream-badge-text">Twitch Stream</span>
		}

		<button
			type="button"
			class="stream-badge-popout"
			title="Pop out video"
			aria-label="Pop out video"
			(click)="onPopoutClicked($event)"
		>
			<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
				<path d="M14 3h7v7" />
				<path d="M10 14L21 3" />
				<rect x="3" y="7" width="14" height="14" rx="2" ry="2" />
			</svg>
		</button>

		<button
			type="button"
			class="stream-badge-close"
			title="Close stream"
			aria-label="Close stream"
			(click)="onCloseClicked($event)"
		>
			✕
		</button>
	</div>
}
